import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, {Navigation} from 'swiper';
Swiper.use([Navigation]);
import 'swiper/css/bundle';
import 'fslightbox';

gsap.registerPlugin(ScrollTrigger);
gsap.config({
    nullTargetWarn: false
});

window.addEventListener("DOMContentLoaded", () => {
    init();
});

function init() {
    sliders();
    sectionSpacing();
    bollenDecor();
}

function sliders() {
    new Swiper('.c-realisations__swiper', {
        navigation: {
            nextEl: ".c-realisations__btn--next",
            prevEl: ".c-realisations__btn--prev",
        },
        spaceBetween: 40,
        speed: 600,
        breakpoints: {
            400: {
                slidesPerView: 1.2
            },
            576: {
                slidesPerView: 1.2
            },
            768: {
                slidesPerView: 2.2
            },
            992: {
                slidesPerView: 3
            }
        }
    });
    new Swiper('.c-slider__swiper', {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 100,
        navigation: {
            nextEl: ".c-slider__btn--next",
            prevEl: ".c-slider__btn--prev",
        },
        breakpoints: {
            400: {
                spaceBetween: 30
            },
            576: {
                spaceBetween: 40
            },
            768: {
                spaceBetween: 50
            },
            992: {
                spaceBetween: 100
            }
        },
        speed: 600
    });

}

function bollenDecor() {
    const main = document.querySelector('main');
    if (!main) return;

    const allSecondary = Array.from(main.querySelectorAll('.o-section--secondary'));

    // Filter: enkel secondary sections waar de volgende section NIET ook secondary is.
    // Zo landen bollen altijd op de laatste section van een geketende groep (niet in het midden van joined sections).
    const candidates = allSecondary.filter((section) => {
        const next = section.nextElementSibling;
        return !next || !next.classList.contains('o-section--secondary');
    });

    // Sla de eerste candidate over — die bevat vaak breadcrumbs/hero
    const secondarySections = candidates.slice(1);
    if (secondarySections.length === 0) return;

    const maxDecor = secondarySections.length >= 3 ? 2 : 1;
    const isWhoItem = main.classList.contains('whoItem');
    const corners = isWhoItem ? ['br', 'bl'] : ['tr', 'tl', 'br', 'bl'];

    // Deterministische pseudo-random op basis van pagina-URL — zelfde pagina = zelfde verdeling
    let seed = 0;
    const path = window.location.pathname;
    for (let i = 0; i < path.length; i++) {
        seed = (seed * 31 + path.charCodeAt(i)) >>> 0;
    }
    const rand = () => {
        seed = (seed * 1664525 + 1013904223) >>> 0;
        return seed / 0xffffffff;
    };

    const indexed = secondarySections.map((el, i) => ({ el, sort: rand(), i }));
    indexed.sort((a, b) => a.sort - b.sort);
    const picked = indexed.slice(0, maxDecor);

    picked.forEach(({ el }) => {
        const corner = corners[Math.floor(rand() * corners.length)];
        el.classList.add('has-decor', `has-decor--${corner}`);
    });
}

function sectionSpacing() {
    const main = document.querySelector('main');
    const sections = main.querySelectorAll('section');
    const bgPrimaryClass = 'o-section--primary';
    const bgClass = 'o-section--bg';
    const bgSecondaryClass = 'o-section--secondary';
    const bgTertiairyClass = 'o-section--tertiairy';
    
    if (!sections.length > 1) return;

    removeSpacing(sections);

    function removeSpacing(section) {

        section.forEach((e) => {
            let sectionPrev = e.previousElementSibling;
            let sectionNext = e.nextElementSibling;

            if (sectionPrev != null) {
                if (containsClass(e, bgPrimaryClass) && containsClass(sectionPrev, bgPrimaryClass) || containsClass(e, bgSecondaryClass) && containsClass(sectionPrev, bgSecondaryClass) || containsClass(e, bgTertiairyClass) && containsClass(sectionPrev, bgTertiairyClass)) {
                    e.classList.add('o-section--pt-0');
                }
            }

            if (sectionNext != null) {
                if (containsClass(e, bgSecondaryClass) && containsClass(sectionNext, bgSecondaryClass) == false || containsClass(e, bgTertiairyClass) && containsClass(sectionNext, bgTertiairyClass) == false) {
                    e.classList.add('o-section--bb');
                }
            }

            if (sectionNext != null) {
                if (containsClass(sectionNext, bgClass) == false) {
                     e.classList.add('o-section--bt-overlap');
                }
            }
        });

        function containsClass(section, className) {
            return section.classList.contains(className);
        }
    }
}
